export const ENERGY_LABEL_COLORS = {
  A: '#007F3E',
  B: '#64A70B',
  C: '#FFD500',
  D: '#FF9E00',
  E: '#FF5E00',
  F: '#D20000',
  G: '#960000',
} as const;
